import axios from 'axios';
import { PAVE_LOCATION_API } from './config';
import publicIp from 'public-ip';

export const getLocationByIP = () => {
  return publicIp
    .v4()
    .then((ip) => {
      return axios
        .get(PAVE_LOCATION_API + 'json/' + ip)
        .then((res) => {
          return res;
        })
        .catch((error) => {
          if (error.response) {
            // console.log(error.response.data.message);
          }
        });
    })
    .catch((error) => console.log(error));
};
